import { render, staticRenderFns } from "./copyShop.vue?vue&type=template&id=bda2ce68&scoped=true"
import script from "./copyShop.vue?vue&type=script&lang=js"
export * from "./copyShop.vue?vue&type=script&lang=js"
import style0 from "./copyShop.vue?vue&type=style&index=0&id=bda2ce68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda2ce68",
  null
  
)

export default component.exports